<div>
    <div class="tab__title">{{ 'locationCommunication' | translate }}</div>

    @if (location().emails.length) {
        <div class="collection">
            @for (mail of location().emails; track mail) {
                <div>
                    <si-icon class="contact-icon" icon="element-mail" />
                    <span>
                        <span>{{ mail.value }} </span>
                    </span>
                </div>
            }
            <div class="divider"></div>
        </div>
    }

    @if (location().phones.length) {
        <div class="collection">
            @for (item of location().phones; track item) {
                <div>
                    <si-icon class="contact-icon" icon="element-phone" />
                    <span>{{ item.value }} </span>
                </div>
            }
            <div class="divider"></div>
        </div>
    }

    @if (location().faxes.length) {
        <div class="collection">
            @for (item of location().faxes; track item) {
                <div>
                    <si-icon class="contact-icon" icon="element-print" />
                    <span>{{ item.value }} </span>
                </div>
            }
            <div class="divider"></div>
        </div>
    }

    @if (location().websiteUrls.length) {
        <div class="collection">
            @for (item of location().websiteUrls; track item) {
                <a [href]="$safeNavigationMigration(item.value)" target="_blank">
                    <si-icon class="contact-icon" icon="element-link" />
                    <span>{{ item.value }} {{ item.description }}</span>
                </a>
            }
            <div class="divider"></div>
        </div>
    }

    @if (location().resourceUrls.length) {
        <div class="collection">
            @for (item of location().resourceUrls; track item) {
                <a [href]="$safeNavigationMigration(item.value)" target="_blank">
                    <si-icon class="contact-icon" icon="element-link" />
                    <span>{{ item.value }} {{ item.description }}</span>
                </a>
            }
            <div class="divider"></div>
        </div>
    }

    @if (location().gps) {
        <div class="collection">
            <div>
                <si-icon class="contact-icon" icon="element-location" />
                <span>{{ location().gps }} </span>
            </div>
        </div>
    }
</div>
